import React, { useEffect, useState } from "react";
import moment from "moment";
import { HStack, Box, VStack, Text, Table, Tr, Td } from "@chakra-ui/react";
import useFetch from "../../../hooks/useFetch";
import { useParams } from "react-router-dom";
import { currencyFormatter } from "../../../Utils/formatUtils";

const Bill = () => {
  const { get } = useFetch();
  const [order, setOrder] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const id = useParams().id;

  useEffect(() => {
    getOrder();
  }, []);

  useEffect(() => {
    if (!isLoading) window.print();
  }, [isLoading]);

  const getOrder = async () => {
    await get(`/orders/${id}`)
      .then((res) => {
        setOrder(res);
        setIsLoading(false);
      })
      .catch((e) => {});
  };

  const calculateTotal = (product) => {
    let total = (
      product.qty *
      product.price *
      0.01 *
      (100 - product.discount)
    ).toFixed(2);
    if (isNaN(total)) return "-";
    return total;
  };

  const getOrderTotal = () => {
    const totalOrder = order.products.reduce((total, item) => {
      const itemPriceWithDiscount = item.price * (1 - item.discount / 100);
      const itemTotal = itemPriceWithDiscount * item.qty;
      return total + itemTotal;
    }, 0);
    return totalOrder;
  };

  return (
    <>
      {isLoading ? (
        <>Cargando </>
      ) : (
        <Box backgroundColor={"white"} height={"100vh"} padding={"2rem 0"}>
          <HStack justifyContent={"space-between"} margin={"0 1rem "}>
            <Box fontWeight={"bold"}>Distribuidora Jea</Box>
            <Box>Pedido Nro.: {order.id}</Box>
            <Box>{moment(order.confirmedAt).format("DD-MM-YYYY")}</Box>
          </HStack>
          <VStack alignItems={"start"} fontSize={"0.9em"} margin={"2rem 1rem "}>
            <Text>Cliente: {order.businessName}</Text>
            <Text>Dirección: {order.address}</Text>
            <Text>
              Zona de Entrega: {order.zoneCode} - {order.zoneName}
            </Text>
            <Text>Fecha de Entrega:</Text>
          </VStack>
          <Box pb={"0.5rem"}>
            <Table variant="simple">
              <thead className=" bg-gray-500 text-white uppercase font-bold text-xs p-1">
                <tr>
                  <th className="text-left w-[10%]">Cantidad</th>
                  <th className="text-left w-[40%]">Descripción</th>
                  <th className="text-left w-[20%]">Precio Unitario</th>
                  <th className="text-left w-[10%]">Descuento</th>
                  <th className="text-left w-[20%]">Precio Total</th>
                </tr>
              </thead>

              <tbody className="text-xs">
                {order.products.map((product) => (
                  <Tr key={product.id}>
                    <Td>{product.qty}</Td>
                    <Td>
                      {product.brand} {product.name}
                    </Td>
                    <Td>{currencyFormatter(product.price)}</Td>
                    <Td>{product.discount}%</Td>
                    <Td>{currencyFormatter(calculateTotal(product))}</Td>
                  </Tr>
                ))}
              </tbody>
            </Table>
            <div className="flex justify-end mt-10">
              <div>
                <div className="text-center w-48 border border-black bg-gray-500 text-white uppercase font-bold text-sm p-1">
                  Total
                </div>
                <div className="text-center w-48">{`${currencyFormatter(
                  getOrderTotal()
                )}`}</div>
              </div>
            </div>
          </Box>
        </Box>
      )}
    </>
  );
};

export default Bill;
